// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class NoReviewerModal extends JQueryView {
  constructor() {
    super('.modal-dialog');

    $('#no-reviewer-modal').modal('show');
  }

  @on({ event: 'click', selector: '#close-button' })
  handleCloseButtonClick() {
    $('#no-reviewer-modal').modal('hide');
  }
}
